// extracted by mini-css-extract-plugin
export default {"column":"FormColumn_column__E7E+d"};